import CalcWidget from "./Calc"

(function() {
    document.querySelectorAll('.calc').forEach((c) => new CalcWidget(c))
})()